export const TimeUtils = {
    getCurrentTime: () => {
        const now = new Date();
        return {
            hour: now
                .getHours()
                .toString()
                .padStart(2, '0'),
            minute: now
                .getMinutes()
                .toString()
                .padStart(2, '0'),
        };
    }
};
